module.exports = __webpack_public_path__ + "static/media/23.021ffb73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/23.svg
// module id = 2815
// module chunks = 3